<template>
  <div>
    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title :content="$t('adicionar-tabela-pacote')"></el-page-header>
      <el-page-header v-if="id !== ''" @back="back" title :content="$t('atualizar-tabela-pacote')"></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        :status-icon="true"
        :rules="rules"
        :inline-message="true"
      >
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="reference">
          <el-checkbox v-model="ruleForm.reference">Tabela de referência</el-checkbox>
          <el-checkbox v-model="ruleForm.courier">Utiliza valor correios</el-checkbox>
        </el-form-item>
        <br />
        <el-form-item style="text-align: center">
          <el-button type="warning" v-if="id === ''" autofocus @click="submitForm('ruleForm')">{{
            $t("adicionar")
          }}</el-button>
          <el-button type="warning" v-if="id !== ''" autofocus @click="editForm('ruleForm')">{{
            $t("atualizar")
          }}</el-button>
          <el-button type="danger" @click="back()">{{ $t("voltar") }}</el-button>
        </el-form-item>
        <br />
        <!--el-tabs v-model="activeTab" type="border-card">
          <el-tab-pane :lazy="true" :label="$t('servicos')" name="tabservices">
            <el-table
              :data="tableServices"
              stripe
              ref="tableServices"
              style="width: 100%"
              :default-sort="{ prop: 'name', order: 'ascending' }"
            >
              <el-table-column type="selection" width="180"></el-table-column>
              <el-table-column
                sortable
                prop="code"
                :label="$t('codigo')"
              ></el-table-column>
              <el-table-column
                sortable
                prop="name"
                :label="$t('nome')"
              ></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs -->
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { PackageTableService } from "@/services/customers/package.table.services";

export default {
  name: "PackageTableAdd",
  data() {
    return {
      tableServices: [],
      id: "",
      activeTab: "tabservices",
      ruleForm: {
        name: "",
        reference: false,
        courier: false,
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({ name: "package.table" });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PackageTableService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          PackageTableService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("tabela-pacote-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          PackageTableService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("tabela-pacote-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      vm.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.name.$el.children[0].focus();
    }
  },
};
</script>
